import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useUpgradePlanModal } from "@/contexts/UpgradePlanModalContext";
import { useRouter } from "next/router";
import { Alert } from "../ui/alert";
import { AlertDialog, AlertDialogContent } from "../ui/alert-dialog";

const UpgradePlanModal = () => {
  const { openUpgradePlan, closeUpgradePlanModal } = useUpgradePlanModal();
  const router = useRouter();

  return (
    <AlertDialog open={openUpgradePlan} onOpenChange={() => {}}>
      <AlertDialogContent className="max-w-md">
        <div className="flex flex-col gap-4">
          <h2 className="text-2xl font-semibold">
            Unlock the full power of Plus100
          </h2>

          <p className="text-sm text-muted-foreground">
            Subscribe to the Pro plan to access all essential features.
          </p>

          <div className="flex justify-end gap-4 mt-4">
            <Button
              className="bg-secondary text-secondary-foreground"
              variant="outline"
              onClick={() => {
                window.open(
                  "https://learn.trylevel2.com/blog/sunsetting-Plus100-free-plan",
                  "_blank"
                );
              }}
            >
              Read announcement
            </Button>
            <Button
              className="bg-[--marketplace-blue] text-secondary font-semibold"
              onClick={() => {
                closeUpgradePlanModal();
                router.push("/subscription");
              }}
            >
              Upgrade now
            </Button>
          </div>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default UpgradePlanModal;
